var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminBillingUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 17.3337H1.33333C1.11232 17.3337 0.900358 17.2459 0.744078 17.0896C0.587797 16.9333 0.5 16.7213 0.5 16.5003V1.50033C0.5 1.27931 0.587797 1.06735 0.744078 0.91107C0.900358 0.75479 1.11232 0.666992 1.33333 0.666992H14.6667C14.8877 0.666992 15.0996 0.75479 15.2559 0.91107C15.4122 1.06735 15.5 1.27931 15.5 1.50033V16.5003C15.5 16.7213 15.4122 16.9333 15.2559 17.0896C15.0996 17.2459 14.8877 17.3337 14.6667 17.3337ZM13.8333 15.667V2.33366H2.16667V15.667H13.8333ZM4.66667 6.50033H11.3333V8.16699H4.66667V6.50033ZM4.66667 9.83366H11.3333V11.5003H4.66667V9.83366Z",
    fill: "#9AA2B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBillingUnselected);
export default __webpack_public_path__ + "static/media/admin_billing_unselected.73867246fbb6fe9eab2d19e256dfbc9c.svg";
export { ForwardRef as ReactComponent };